import React, { useState, useEffect, forwardRef, useCallback } from "react";
import classNames from "classnames";
import IEditableProps from "../../utilities/IEditableProps";
import IStyledProps from "../../utilities/IStyledProps";
import AdvisorGrid from "./AdvisorGrid";
import AdvisorSearch from "./AdvisorSearch";
import AdvisorHeader from "./AdvisorHeader";
import { getAdvisorsByCode, searchAdvisors } from "./services/WealthAdvisorService";
import IEmployee from "./models/IEmployee";
import IGeoPosition from "./models/IGeoPosition";

export interface IWealthAdvisorLookupProps extends IEditableProps, IStyledProps {
    defaultAdvisors: string;
    limit: number;
    defaultRadius: number;
}

const WealthAdvisorLookup = forwardRef(({ defaultAdvisors, limit = 4, defaultRadius= 5, cmsId, editorClassObj }: IWealthAdvisorLookupProps, ref: any) => {
    const [userLocation, setUserLocation] = useState<IGeoPosition|null>();
    const [searchParams, setSearchParams] = useState({latitude: '', longitude: '', radius: '', address: ''});
    const [advisors, setAdvisors] = useState<IEmployee[]>([]);
    const [virtualAdvisors, setVirtualAdvisors] = useState<IEmployee[]>([]);
    const [isLoading, setLoading] = useState(false);
    const [isSearch, setSearch] = useState(false);
    const loadMap = process.env.GATSBY_LOAD_MAP === "true";

    function tryGeolocation() {
        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                setUserLocation({ lat: position.coords.latitude, lng: position.coords.longitude });
            });
        }
    }

    const onSearch = useCallback(async (latitude, longitude, radius, address) => {
        setSearchParams({latitude, longitude, radius, address});
        setLoading(true);
        const { localWealthAdvisors, virtualWealthAdvisors } = await searchAdvisors(latitude, longitude, radius, limit);
        setVirtualAdvisors(virtualWealthAdvisors);
        setAdvisors(localWealthAdvisors);
        setLoading(false);
        setSearch(true);
    }, []);

    useEffect(() => {
        if (window) {
            tryGeolocation();
        }
    }, []);

    useEffect(() => {
        async function load() {
            if (defaultAdvisors) {
                setLoading(true);
                setAdvisors(await getAdvisorsByCode(defaultAdvisors));
                setLoading(false);
            }
        }
        load();
    }, [defaultAdvisors]);

    return (
        <div data-id={cmsId} ref={ref} className={classNames("m-0 w-100", editorClassObj)}>
            <AdvisorHeader />
            <AdvisorSearch loadMap={loadMap} onSearch={onSearch} userLocation={userLocation} defaultRadius={defaultRadius} />
            <AdvisorGrid isSearch={isSearch} isLoading={isLoading} advisors={advisors} virtualAdvisors={virtualAdvisors} radius={searchParams.radius} address={searchParams.address} />
        </div>
    );
});

export default WealthAdvisorLookup;